import { render } from "./oncology_investigations.vue?vue&type=template&id=659de8dc&scoped=true"
import script from "./oncology_investigations.vue?vue&type=script&lang=js"
export * from "./oncology_investigations.vue?vue&type=script&lang=js"

import "./oncology_investigations.vue?vue&type=style&index=0&id=659de8dc&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659de8dc"]])

export default __exports__